// src/reducers/customerReducer.js

import {types} from '../types/types';

const initialState = {
    editingCustomer: {
        abbreviation: '',
        address: '',
        addressCode: '',
        code: '',
        concept: '',
        creditLimit: '',
        discountCount: '',
        documentType: '',
        id: 0,
        itsWarehouse: true,
        latitud: '',
        longitud: '',
        name: '',
        priceArea: '',
        radio: '',
        realmFk: '',
        rnc: '',
        socialReason: '',
        status: true,
        tel: '',
        typeNcf: '',
    },
    availableCustomers: [],
    CustomersGroupAssociationResponse: null,
};

export const customerReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.editingCustomerInfo:
            return {
                ...state,
                editingCustomer: action.payload,
            };

            case types.CustomersGroupAssociationResponse:
      return {
        ...state,
        CustomersGroupAssociationResponse: action.payload
      };

      case types.ClearCustomersGroupAssociationResponse:
  return {
    ...state,
    CustomersGroupAssociationResponse: null
  };

        case types.clearCustomerInfo:
            return {
                ...state,
                editingCustomer: initialState.editingCustomer,
            };
        case types.setAvailableCustomers:
            return {
                ...state,
                availableCustomers: action.payload
            };

        default:
            return state;
    }
};